// ============================================================================
// ARBITRATOR ENDPOINTS
// ============================================================================
// BASE_PATH must match backend ArbitratorController → /Arbitrator.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const ARBITRATOR_BASE_PATH = '/Arbitrator';

export const arbitratorEndpoints = {
  list: () => buildEndpoint(ARBITRATOR_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${ARBITRATOR_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${ARBITRATOR_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(ARBITRATOR_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${ARBITRATOR_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${ARBITRATOR_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${ARBITRATOR_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default arbitratorEndpoints;
